import styled, { css } from 'styled-components';
import { gridSizes } from 'utils/style';

const ShipmentCardIconButton = styled.button`
  position: absolute;
  right: ${gridSizes('S')};
  top: ${gridSizes('S')};
  display: block;
  border: none;
  cursor: pointer;
  width: 24px;
  height: 24px;
  background: none;
  background-color: transparent;
  /* background-color: red; */
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  svg,
  svg path {
    width: 16px;
    height: 16px;
    fill: var(--primary500);
  }
  ${(props) =>
    !props.disabled &&
    css`
      &:hover {
        background-color: var(--primary100);
      }
      &:active,
      :focus {
        background-color: var(--primary300);
        svg,
        svg path {
          fill: var(--white);
        }
      }
    `};
  ${(props) =>
    !props.disabled &&
    !!props.opened &&
    css`
      background-color: var(--primary300);
      svg,
      svg path {
        fill: var(--white);
      }
    `};
`;

export default ShipmentCardIconButton;
